import SliderBase from './base-slider';

class CategorySliderHandler extends SliderBase {

}

export default ( $scope ) => {
	elementorFrontend.elementsHandler.addHandler( CategorySliderHandler, { $element: $scope } );
};
